import { Step } from 'react-joyride';

export const sellerProfileSteps: Step[] = [
  {
    target: 'body',
    content: 'Manage your seller account, market preferences, and subscription settings all in one place.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="profile-tabs"]',
    content: 'Navigate between Personal Info, Markets, Subscription, and Billing tabs to manage different aspects of your account.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="profile-image"]',
    content: 'Upload a professional photo to build trust with buyers. First impressions matter in real estate.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="personal-info"]',
    content: 'Keep your business contact information updated so buyers can reach you about your listings.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="security-section"]',
    content: 'Protect your account with password management and two-factor authentication (2FA).',
    disableBeacon: true,
  },
];
